// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-document-CompleteBox-CompleteBox-module__pageLayout-eKl38I","headerTable":"src-app-pages-electronic-document-CompleteBox-CompleteBox-module__headerTable-Ntj_14"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-document-CompleteBox-CompleteBox-module__pageLayout-eKl38I\",\"headerTable\":\"src-app-pages-electronic-document-CompleteBox-CompleteBox-module__headerTable-Ntj_14\"}";
        // 1789362522829
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  